export default {
  nav: {
    home: 'Home',
    about: 'About Us',
    programs: 'Our Programs',
    gallery: 'Gallery',
    news: 'News & Events',
    contact: 'Contact',
    donate: 'Donate Now',
  },
  brand: { name: 'Hind Kranti Sena', sub: 'Foundation' },
  common: { comingSoon: 'Coming soon', donateDisabledTitle: 'Online donations are launching soon' },
  footer: {
    about: "An Indian nonprofit working towards women's safety and empowerment, animal welfare, environmental conservation, and clean, healthy communities.",
    quickLinks: 'Quick Links',
    focusAreas: 'Focus Areas',
    getInTouch: 'Get in Touch',
    address: 'Raipur, Chhattisgarh',
    copyright: 'Hind Kranti Sena Foundation. All rights reserved.',
    privacy: 'Privacy Policy',
  },
  home: {
    hero: {
      eyebrow: 'Rashtriya Hind Kranti Sena Foundation',
      title: 'Standing up for women, animals, and the environment we all share.',
      subtitle: "A grassroots Indian nonprofit working on women's safety & empowerment, animal welfare, environmental conservation, and clean, healthy communities — one neighbourhood at a time.",
      volunteer: 'Become a Volunteer',
    },
    stats: {
      volunteers: 'Volunteers engaged',
      localities: 'Villages & localities reached',
      trees: 'Trees planted',
      focus: 'Focus areas, one mission',
    },
    pillars: {
      eyebrow: 'What We Do',
      title: 'Four pillars, one mission',
      subtitle: 'Everything we do fits under these interconnected causes.',
      learnMore: 'Learn more',
      women: { title: 'Women Safety & Empowerment', text: 'Advocacy, survivor support, and skill-building for women and girls.' },
      animals: { title: 'Animal Welfare', text: 'Rescue, treatment, and adoption drives for street and orphaned animals.' },
      environment: { title: 'Environmental Conservation', text: 'Tree plantation, biodiversity, and community-led sustainability.' },
      clean: { title: 'Clean Communities', text: 'Sanitation drives and litter-free, healthier public spaces.' },
    },
    about: {
      eyebrow: 'Who We Are',
      title: 'Community-led change, built to last',
      text: 'Hind Kranti Sena Foundation brings together volunteers, local leaders, and partner organisations to challenge gender-based violence, protect vulnerable animals, restore green cover, and keep our cities and villages clean. We believe lasting change is built with communities, not handed down to them.',
      cta: 'More About Us',
      valuesTitle: 'Our Values',
      v1: 'Compassion in every action',
      v2: 'Community-first decision making',
      v3: 'Transparency & accountability',
      v4: 'Sustainable, long-term impact',
    },
    involve: {
      eyebrow: 'Get Involved',
      title: 'Three ways you can help today',
      donateTitle: 'Donate',
      donateText: 'Fund rescue operations, plantation drives, and support for women in crisis.',
      volunteerTitle: 'Volunteer',
      volunteerText: 'Join clean-up drives, rescue teams, or community outreach in your area.',
      volunteerBtn: 'Join Us',
      partnerTitle: 'Partner With Us',
      partnerText: "Corporates, NGOs and community groups — let's collaborate on impact.",
      partnerBtn: 'Get in Touch',
    },
    cta: {
      title: 'Join the movement for a safer, greener India',
      text: 'Every rupee, every hour, and every voice helps us go further.',
      programs: 'See Our Programs',
    },
  },
  about: {
    hero: { eyebrow: 'About Us', title: 'People-powered change, on the ground', subtitle: 'Who we are, what we stand for, and how we work.' },
    mission: { title: 'Our Mission', text: 'To challenge gender-based violence and inequity, protect animals from cruelty and neglect, restore green cover, and build clean, healthy communities across India — through direct action, advocacy, and community partnership.' },
    vision: { title: 'Our Vision', text: 'An India where women and girls live free from violence, animals are treated with compassion, the environment is protected for future generations, and every neighbourhood is clean and healthy.' },
    approach: {
      eyebrow: 'Our Approach',
      title: 'How we work',
      communityLed: { title: 'Community-Led', text: 'We mobilise local volunteers and leaders instead of working around them.' },
      advocacy: { title: 'Advocacy-Driven', text: 'We push for stronger policy and enforcement alongside on-ground relief.' },
      partnership: { title: 'Partnership-First', text: 'We collaborate with NGOs, civic bodies, and volunteers to go further, together.' },
    },
    values: {
      eyebrow: 'Core Values',
      title: 'What guides every decision we make',
      compassion: { title: 'Compassion', text: 'For people, animals, and the planet alike.' },
      integrity: { title: 'Integrity', text: 'Honest, transparent, accountable in everything we do.' },
      sustainability: { title: 'Sustainability', text: 'Solutions built to outlast a single campaign.' },
      inclusion: { title: 'Inclusion', text: 'Everyone has a role to play in this mission.' },
    },
    cta: { title: 'Want to be part of the story?', text: 'Volunteer your time, skills, or support — every bit moves us forward.', getInvolved: 'Get Involved' },
  },
  programs: {
    hero: { eyebrow: 'Our Programs', title: 'Where our work happens', subtitle: 'Four focus areas, each backed by dedicated volunteers and partners.' },
    women: {
      title: 'Women Safety & Empowerment',
      intro: 'Advocacy against gender-based violence, direct support for survivors, and workshops that build economic and social independence for women and girls.',
      goal1: 'Run awareness workshops on rights, safety, and equity',
      goal2: 'Connect survivors with legal aid and counselling support',
      goal3: 'Support skill-building and livelihood programs for women',
    },
    animals: {
      title: 'Animal Welfare & Rescue',
      intro: 'Rescue and treatment for street and orphaned animals, sterilisation drives, and adoption support, alongside anti-cruelty advocacy.',
      goal1: 'Respond to rescue calls for injured or at-risk animals',
      goal2: 'Support vaccination and sterilisation camps',
      goal3: 'Facilitate responsible adoptions within the community',
    },
    environment: {
      title: 'Environmental Conservation',
      intro: 'Tree plantation drives, biodiversity awareness, and sustainability education that involve the whole community, not just volunteers.',
      goal1: 'Organise regular plantation drives in partnership with local bodies',
      goal2: 'Promote native species and long-term tree upkeep',
      goal3: 'Run sustainability and climate-awareness sessions in schools',
    },
    clean: {
      title: 'Clean & Healthy Communities',
      intro: 'Litter-prevention drives, sanitation awareness, and clean-up campaigns for public spaces, drains, and water bodies.',
      goal1: 'Run regular neighbourhood and public-space clean-up drives',
      goal2: 'Promote waste segregation and responsible disposal habits',
      goal3: 'Partner with local authorities on sanitation infrastructure',
    },
    cta: { title: 'Want to support one of these programs?', text: "Choose a cause when you donate, or tell us where you'd like to volunteer.", volunteer: 'Volunteer' },
  },
  gallery: {
    hero: { eyebrow: 'Gallery', title: 'Our work, in pictures', subtitle: 'A look at our volunteers and communities in action.' },
    women: { title: 'Women Safety & Empowerment', caption: 'Workshops, outreach, and survivor support sessions.' },
    tree: { title: 'Tree Plantation Drives', caption: 'Community plantation days across neighbourhoods.' },
    animal: { title: 'Animal Rescue', caption: 'Rescue, treatment, and adoption stories.' },
    clean: { title: 'Clean-Up Campaigns', caption: 'Volunteers keeping public spaces litter-free.' },
    note: "📸 Have photos from a recent drive or event? Send them our way and we'll feature them here.",
  },
  donate: {
    hero: { eyebrow: 'Donate', title: 'Your support funds real, on-ground work', subtitle: 'Every contribution helps rescue an animal, plant a tree, support a survivor, or clean up a neighbourhood.' },
    disabled: {
      title: 'Online donations are launching soon',
      text: "We're setting up secure online payments. Until then, please reach out to us directly and our team will help you contribute.",
      contactBtn: 'Contact Us',
    },
  },
  contact: {
    hero: { eyebrow: 'Contact Us', title: "Let's work together", subtitle: "Questions, partnerships, or ready to volunteer — we'd love to hear from you." },
    info: { title: 'Reach Us Directly' },
    volunteerInterests: {
      title: 'Volunteer Interests',
      women: 'Women Safety', animals: 'Animal Rescue', trees: 'Tree Plantation', clean: 'City Clean-Ups', advocacy: 'Advocacy',
    },
    form: {
      title: 'Send a Message',
      namePh: 'Name', emailPh: 'Email', interestPh: "I'm interested in…",
      messagePh: "Message (e.g., I'd like to volunteer for tree planting drives)",
      submit: 'Send Message',
      other: 'Something else',
    },
    thanks: { title: 'Message received!', text: "Thanks for reaching out — our team will get back to you soon." },
  },
  news: {
    hero: { eyebrow: 'News & Events', title: "What we've been up to", subtitle: 'Recent updates and upcoming ways to get involved.', note: '(Sample entries — replace with your real updates.)' },
    latestHead: 'Latest Updates',
    upcomingHead: 'Upcoming Events',
    l1: { date: 'Aug 2026', title: 'Gender Equity Outreach Session', text: "A community workshop on women's rights and workplace equity." },
    l2: { date: 'Jul 2026', title: 'Community Animal Rescue Drive', text: 'Volunteers supported treatment and shelter for street animals.' },
    l3: { date: 'Jun 2026', title: 'Neighbourhood Clean-Up Day', text: 'Local volunteers ran a litter-collection and awareness drive.' },
    u1: { date: 'Oct 2026', title: 'Women Safety Workshop', text: 'Awareness and self-defence session for local women and girls.' },
    u2: { date: 'Nov 2026', title: 'Tree Plantation Drive', text: 'Community plantation event — volunteers welcome.' },
    u3: { date: 'Dec 2026', title: 'Animal Adoption Fair', text: 'Meet rescued animals ready for a loving home.' },
    u4: { date: 'Jan 2027', title: 'City Clean-Up Day', text: 'Join us for a large-scale neighbourhood clean-up.' },
  },
};
